import { C } from '@parsina/framework/clinical/src/constants/theme';
import { CT, soft } from '@parsina/framework/tokens';
import { visitOverrun } from '../hooks/useReception';
import { formatDuration } from '../lib/appointments';
import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';

// The DESKTOP forgotten-visit banner. The mobile surface renders its own
// `MobileForgottenVisitAlert` (src/components/mobile/); both describe the same
// condition — a visit left open (> 2h, or from a previous day) that follows the
// doctor to every date until it is continued or closed.


const ForgottenVisitBanner = ({ visits, nowMs, onContinue, onEnd }) => {
  const { t } = useTranslation();
  if (!visits.length) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
      {visits.map(apt => {
        const { elapsedMin } = visitOverrun(apt, nowMs);
        return (
          <div key={apt.id} style={{
            display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
            background: C.redLight, border: `1.5px solid ${soft(C.red, 0.35)}`,
            borderRadius: 14, padding: '12px 18px',
          }}>
            <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 20, padding: '3px 10px', background: soft(C.red, 0.12), color: CT.dangerInk, flexShrink: 0 }}>
              {t('dashboard.forgotten.title')}
            </span>
            <div style={{ flex: 1, minWidth: 180, fontSize: 13, fontWeight: 700, color: CT.dangerInk }}>
              {t('dashboard.forgotten.body', { name: apt.name || t('common.labels.patient') })}
              {elapsedMin != null && (
                <span style={{ fontWeight: 600, color: CT.dangerInk, marginInlineStart: 6 }}>
                  {t('dashboard.forgotten.elapsed', { duration: formatDuration(t, elapsedMin) })}
                </span>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
              <button onClick={() => onContinue(apt)} style={{
                height: 32, padding: '0 14px', background: 'white', color: CT.dangerInk,
                border: `1.5px solid ${soft(C.red, 0.35)}`, borderRadius: 9, fontSize: 12, fontWeight: 700, cursor: 'pointer',
              }}>{t('dashboard.hero.continueVisit')}</button>
              <button onClick={() => onEnd(apt)} style={{
                height: 32, padding: '0 14px', background: C.red, color: 'white',
                border: 'none', borderRadius: 9, fontSize: 12, fontWeight: 800, cursor: 'pointer',
              }}>{t('dashboard.hero.endVisit')}</button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ForgottenVisitBanner;
